<!-- src/components/aics/AnythingllmRichEditor.vue -->
<template>
  <div>
    <div class="rich-editor-container" :style="{ height: editorContainerHeight }">
      <!-- 富文本编辑器区域 -->
      <div class="editor-section">
        <div class="editor-header">
      <!-- 左侧：文档标题和状态 -->
  <div class="document-title-section">
    
    <span class="document-title" v-if="currentEditDoc?.title || form.title">
      | {{ currentEditDoc?.title || form.title }}
      <el-tag 
        size="mini" 
        :type="saveStatus === 'saved' ? 'success' : 'warning'"
        class="title-status-tag"
      >
        {{ saveStatusText }}
      </el-tag>
    </span>
  </div>
               <!-- 在工具栏中间添加统计信息 -->
          <div class="editor-stats">
            <span class="stat-item" :class="{ 'limit-exceeded': wordCount > 5000 }">
              <svg t="1764597757420" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10423" width="14" height="14">
                <path d="M512 853.333333c-263.9872 0-477.866667-284.672-477.866667-341.230933C34.133333 471.3472 248.0128 170.666667 512 170.666667c263.918933 0 477.866667 303.445333 477.866667 341.435733C989.7984 568.900267 775.850667 853.333333 512 853.333333z m-6.144-521.1136c-127.658667 0-276.5824 60.279467-276.5824 187.938134s148.8896 174.318933 276.548267 174.318933s279.005867-46.660267 279.005866-174.318933-151.3472-187.938133-279.005866-187.938134z m2.594133 93.7984a79.325867 79.325867 0 0 0 79.223467 79.291734c10.376533 0 19.968-2.1504 29.013333-5.563734 0.341333 3.6864 1.297067 7.202133 1.297067 11.0592a113.220267 113.220267 0 1 1-226.542933 0 113.322667 113.322667 0 0 1 113.220266-113.3568c3.1744 0 6.178133 0.7168 9.216 0.989867-3.345067 8.6016-5.4272 17.749333-5.4272 27.579733z" fill="#1296db" p-id="10424"></path>
              </svg>
              字数: {{ wordCount }}/5000
            </span>
            <span class="stat-divider">|</span>
            <span class="stat-item" :class="{ 'limit-exceeded': imageCount > 50 }">
              <svg t="1764597531303" class="icon" viewBox="0 0 1250 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6945" width="14" height="14">
                <path d="M371.70688 62.82752l130.26304 25.70752H300.96896c10.43456-31.11936 27.4432-34.2016 70.73792-25.70752z m796.4928 228.26496l-112.1024 614.8096c-10.62912 57.78944-23.97696 66.10432-78.08512 55.27552l-130.64704-25.90208h61.45536c27.63776 0 58.76224-1.93024 80.4096-23.77216 22.22592-22.62528 23.9616-55.66464 23.9616-84.84864V189.42976l101.86752 20.096c55.26016 11.2128 63.3856 25.50784 53.14048 81.56672z" fill="#1296db" opacity=".4" p-id="6946"></path>
                <path d="M894.39744 136.88832H147.26656c-38.25152 0-69.26848 31.02208-69.26848 69.26848v626.98496c0 38.2464 31.01696 69.26336 69.26848 69.26336h747.13088c38.26176 0 69.2736-31.02208 69.2736-69.26336V206.1568c0-38.25152-31.01696-69.26848-69.2736-69.26848zM300.96896 275.06688c45.42464 0 82.1504 38.07744 82.1504 85.43744 0 47.16032-36.72576 85.4272-82.1504 85.4272-45.41952 0-82.14528-38.26688-82.14528-85.4272 0-47.17056 36.72576-85.43744 82.14528-85.43744z m-89.0368 479.32928c1.152-0.96768 115.3792-184.77568 149.5808-184.77568 33.62816 0 97.79712 89.28256 97.79712 89.28256 49.8688-53.52448 160.22528-205.63456 192.70656-205.63456 33.62304 0 165.83168 188.2368 240.0512 301.12768H211.93216z" fill="#1296db" p-id="6947"></path>
              </svg>
              图片: {{ imageCount }}/50
            </span>
          </div>
          <div class="editor-actions">
            <el-tooltip content="保存" placement="top">
              <el-button 
                size="mini" 
                @click="handleSave"
                circle
              >
                <svg t="1764597102039" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5551" width="16" height="16">
                  <path d="M1022.503684 339.908142v-17.102296c0-0.732956-4.031256-24.431852-6.107963-32.372204a164.487444 164.487444 0 0 0-17.835252-29.929019l-7.512795-8.001432L788.324382 37.747211l-5.802565-6.107963a120.815508 120.815508 0 0 0-82.823979-31.150611l-6.901998-0.488637H184.735476A183.971846 183.971846 0 0 0 1.130108 184.094005v655.75091a184.155085 184.155085 0 0 0 183.727528 184.094005h654.162839a184.155085 184.155085 0 0 0 183.727527-184.094005V339.908142zM184.002521 98.216045h505.067462v96.627975a105.301282 105.301282 0 0 1-104.995885 105.240203H288.937325a105.301282 105.301282 0 0 1-104.995884-105.240203zM839.75343 926.51691H484.819699v-251.098359h-189.346853v251.098359H184.002521V635.350313a85.511482 85.511482 0 0 1 85.511482-85.511482h484.911184a85.511482 85.511482 0 0 1 85.511482 85.511482v291.044438z" fill="#1D85ED" p-id="5552"></path>
                </svg>
              </el-button>
            </el-tooltip>              
    <!-- 另存为按钮 -->
    <el-tooltip content="另存为" placement="top">
      <el-button 
        size="mini" 
        @click="handleSaveAs"
        circle

      >
        <svg t="1786432167592" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1971" width="16" height="16"><path d="M768.17 541.26l-65.56 65.56 77.95 78.19H509.81v92.75h273.9l-80.61 80.62 65.56 65.8L960 732.84z" p-id="1972" fill="#1296db"></path><path d="M166.95 498.77h720.93V292.86L695.08 99.82H64V923.7h488.31V820.75h-385.6V498.77h0.24z m0-296.24h437.8v128.45h-437.8V202.53z" p-id="1973" fill="#1296db"></path></svg>
        
      </el-button>
    </el-tooltip>            
            <el-tooltip content="插入图片" placement="top">
              <el-button 
                size="mini" 
                @click="handleInsertImage"            
                circle
              >
                <svg t="1764597531303" class="icon" viewBox="0 0 1250 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6945" width="20" height="20">
                  <path d="M371.70688 62.82752l130.26304 25.70752H300.96896c10.43456-31.11936 27.4432-34.2016 70.73792-25.70752z m796.4928 228.26496l-112.1024 614.8096c-10.62912 57.78944-23.97696 66.10432-78.08512 55.27552l-130.64704-25.90208h61.45536c27.63776 0 58.76224-1.93024 80.4096-23.77216 22.22592-22.62528 23.9616-55.66464 23.9616-84.84864V189.42976l101.86752 20.096c55.26016 11.2128 63.3856 25.50784 53.14048 81.56672z" fill="#1296db" opacity=".4" p-id="6946"></path>
                  <path d="M894.39744 136.88832H147.26656c-38.25152 0-69.26848 31.02208-69.26848 69.26848v626.98496c0 38.2464 31.01696 69.26336 69.26848 69.26336h747.13088c38.26176 0 69.2736-31.02208 69.2736-69.26336V206.1568c0-38.25152-31.01696-69.26848-69.2736-69.26848zM300.96896 275.06688c45.42464 0 82.1504 38.07744 82.1504 85.43744 0 47.16032-36.72576 85.4272-82.1504 85.4272-45.41952 0-82.14528-38.26688-82.14528-85.4272 0-47.17056 36.72576-85.43744 82.14528-85.43744z m-89.0368 479.32928c1.152-0.96768 115.3792-184.77568 149.5808-184.77568 33.62816 0 97.79712 89.28256 97.79712 89.28256 49.8688-53.52448 160.22528-205.63456 192.70656-205.63456 33.62304 0 165.83168 188.2368 240.0512 301.12768H211.93216z" fill="#1296db" p-id="6947"></path>
                </svg>
              </el-button>
            </el-tooltip>
            <el-tooltip content="切换预览/编辑状态" placement="top">
              <el-button 
                size="mini" 
                @click="togglePreview"
                circle
              >
                <svg v-if="!showPreview" t="1764597757420" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10423" width="16" height="16">
                  <path d="M512 853.333333c-263.9872 0-477.866667-284.672-477.866667-341.230933C34.133333 471.3472 248.0128 170.666667 512 170.666667c263.918933 0 477.866667 303.445333 477.866667 341.435733C989.7984 568.900267 775.850667 853.333333 512 853.333333z m-6.144-521.1136c-127.658667 0-276.5824 60.279467-276.5824 187.938134s148.8896 174.318933 276.548267 174.318933s279.005867-46.660267 279.005866-174.318933-151.3472-187.938133-279.005866-187.938134z m2.594133 93.7984a79.325867 79.325867 0 0 0 79.223467 79.291734c10.376533 0 19.968-2.1504 29.013333-5.563734 0.341333 3.6864 1.297067 7.202133 1.297067 11.0592a113.220267 113.220267 0 1 1-226.542933 0 113.322667 113.322667 0 0 1 113.220266-113.3568c3.1744 0 6.178133 0.7168 9.216 0.989867-3.345067 8.6016-5.4272 17.749333-5.4272 27.579733z" fill="#1296db" p-id="10424"></path>
                </svg>
                <svg v-if="showPreview" t="1764597842625" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11558" width="16" height="16">
                  <path d="M164.6 762.9c18.5 18.5 48.1 19.9 68.2 3.2l55.2-45.8-80.8-80.8-45.8 55.2c-16.7 20.1-15.3 49.7 3.2 68.2zM842.4 260.3c56.4-46.8 60.4-132 8.6-183.9-51.9-51.8-137.1-47.8-183.9 8.6l-40 48.2 167.1 167.1 48.2-40zM714.1 366.8L560.7 213.3 273.6 559.4l94.5 94.4zM968.6 877.9H55.4C24.8 877.9 0 902.8 0 933.4s24.8 55.4 55.4 55.4h913.2c30.6 0 55.4-24.8 55.4-55.4 0-30.6-24.8-55.5-55.4-55.5z" p-id="11559" fill="#1296db"></path>
                </svg>
              </el-button>
            </el-tooltip>
            <el-tooltip content="清除格式" placement="top">
              <el-button 
                size="mini" 
                @click="handleClearFormat"
                circle
              >
                <svg t="1764597697707" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9238" width="16" height="16">
                  <path d="M953.408 407.68a39.701333 39.701333 0 0 1 0 56.170667l-365.013333 365.013333a39.701333 39.701333 0 0 1-56.170667 0L195.285333 491.946667a39.701333 39.701333 0 0 1 0-56.149334l365.013334-365.013333a39.701333 39.701333 0 0 1 56.170666 0L953.386667 407.68z m-83.072 29.269333L587.221333 153.813333 236.224 504.810667l283.136 283.114666 350.976-350.976z" fill="#1296db" p-id="9239"></path>
                  <path d="M226.218667 434.986667l362.944 362.944a21.333333 21.333333 0 0 1 0 30.165333L450.858667 966.4a21.333333 21.333333 0 0 1-30.165334 0L57.749333 603.477333a21.333333 21.333333 0 0 1 0-30.186666L196.053333 434.986667a21.333333 21.333333 0 0 1 30.165334 0z" fill="#1296db" p-id="9240"></path>
                </svg>
              </el-button>
            </el-tooltip>
            <!-- 调整图片大小按钮 -->
        <el-tooltip content="调整图片大小" placement="top">
          <el-button 
            size="mini" 
            @click="handleImageResize"
            :class="{ 'highlight-button': hasSelectedImage }"
            circle
          >
            <svg t="1768220644507" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5635" width="16" height="16">
              <path d="M368.64 194.56a10.24 10.24 0 0 1 1.19808 20.40832L368.64 215.04H229.5296l282.46016 282.4704L794.46016 215.04H655.36a10.24 10.24 0 0 1-10.16832-9.04192L645.12 204.8a10.24 10.24 0 0 1 9.04192-10.16832L655.36 194.56h164.0448c0.23552 0 0.47104 0.02048 0.7168 0.04096L819.2 194.56a10.32192 10.32192 0 0 1 6.31808 2.18112c0.64512 0.512 1.2288 1.08544 1.7408 1.7408l-0.8192-0.9216a10.32192 10.32192 0 0 1 2.92864 6.0416l0.03072 0.3072 0.03072 0.5632L829.44 204.8v163.84a10.24 10.24 0 0 1-20.40832 1.19808L808.96 368.64V229.51936L526.47936 512 808.96 794.4704V655.36a10.24 10.24 0 0 1 9.04192-10.16832L819.2 645.12a10.24 10.24 0 0 1 10.16832 9.04192L829.44 655.36v164.17792l-0.04096 0.53248L829.44 819.2a10.32192 10.32192 0 0 1-2.18112 6.31808c-0.512 0.64512-1.09568 1.2288-1.7408 1.7408l0.9216-0.8192a10.32192 10.32192 0 0 1-6.0416 2.92864l-0.32768 0.03072a10.30144 10.30144 0 0 1-0.53248 0.03072L819.2 829.44H655.36a10.24 10.24 0 0 1-1.19808-20.40832L655.36 808.96h139.1104L512 526.4896 229.51936 808.96H368.64a10.24 10.24 0 0 1 10.16832 9.04192L378.88 819.2a10.24 10.24 0 0 1-9.04192 10.16832L368.64 829.44H204.47232l-0.55296-0.04096L204.8 829.44a10.32192 10.32192 0 0 1-6.31808-2.18112 10.32192 10.32192 0 0 1-1.7408-1.7408l0.8192 0.9216a10.32192 10.32192 0 0 1-2.92864-6.0416l-0.03072-0.32768A10.30144 10.30144 0 0 1 194.56 819.4048V655.36a10.24 10.24 0 0 1 20.40832-1.19808L215.04 655.36v139.10016L497.5104 512 215.04 229.5296V368.64a10.24 10.24 0 0 1-9.04192 10.16832L204.8 378.88a10.24 10.24 0 0 1-10.16832-9.04192L194.56 368.64V204.8l0.03072-0.768 0.17408-1.29024 0.3072-1.13664 0.45056-1.13664 0.53248-1.00352 0.68608-0.98304 0.8192-0.9216a10.3424 10.3424 0 0 1 1.14688-0.99328l1.1264-0.72704 1.16736-0.55296 1.0752-0.3584 1.536-0.3072L204.8 194.56h163.84z" :fill="hasSelectedImage ? '#FF6B6B' : '#1296db'" p-id="5636"></path>
            </svg>
          </el-button>
        </el-tooltip>  
          </div>
        </div>
       <!-- 核心：固定高度的编辑/预览区域 -->
      <div class="editor-main-area" ref="editorMainArea">
        <!-- 编辑器 -->
        <div v-show="!showPreview" class="editor-wrapper">
          <quill-editor
            ref="quillEditor"
            v-model="form.htmlContent"
            :options="editorOptions"
            @ready="onEditorReady"
            @change="onContentChange"
            class="quill-editor"
          />
        </div>
        
        <!-- 预览区域 -->
        <div v-show="showPreview" class="preview-wrapper">
          <div class="preview-content" v-html="form.htmlContent"></div>
          <div v-if="!form.htmlContent" class="preview-empty">
            <el-empty description="暂无内容" :image-size="80"></el-empty>
          </div>
        </div>
        
        <!-- 字数统计 -->
        <div class="editor-footer">
          <div class="word-count">
            <span>字数: {{ wordCount }} 字</span>
            <span class="divider">|</span>
            <span>图片: {{ imageCount }} 张</span>
          </div>
        </div>
      </div>
    </div>

      <!-- 图片选择器对话框 -->
      <el-dialog
        title="选择图片"
        :visible.sync="imagePickerVisible"
        width="90%"
        top="5vh"
        append-to-body
        :close-on-click-modal="false"
      >
        <div class="image-picker-dialog">
          <ImageLibrarySelector
            ref="imageLibrary"
            selection-mode="single"  
            :show-upload="true"
            @image-selected="handleImageSelected"
            @cancel="handleImagePickerCancel"
          ></ImageLibrarySelector>
        </div>
      </el-dialog>
      
      <!-- 保存图文文档时，弹出的图文文档基本信息对话框 -->
      <el-dialog
        title="请编辑图文文档的基本信息"
        :visible.sync="open_editor_baseinfo"
        width="700px"
        top="2vh"
        append-to-body
        :close-on-click-modal="false"
        custom-class="editor-dialog"
      >
        <el-form :model="form" :rules="rules" ref="editorForm" label-width="160px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="文档标题" prop="title">
                <el-input 
                  v-model="form.title" 
                  placeholder="请输入文档标题"
                  maxlength="100"
                  show-word-limit
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="文档目录" prop="dirId">
                <a title="文档目录同图片库的图片分类，您可以在【图片库管理】/【图片及图文文档分类管理】中管理此分类" style="cursor: pointer;">
                  <svg t="1767786622405" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5583" width="16" height="16">
                    <path d="M512 85.333333c235.637333 0 426.666667 191.029333 426.666667 426.666667S747.637333 938.666667 512 938.666667 85.333333 747.637333 85.333333 512 276.362667 85.333333 512 85.333333z m0 586.666667a32 32 0 1 0 0 64 32 32 0 0 0 0-64z m-2.517333-373.333333c-48.416 0-92.746667 24.16-118.613334 63.413333a137.088 137.088 0 0 0-15.978666 33.237333 32 32 0 0 0 60.906666 19.690667c2.016-6.24 4.885333-12.202667 8.522667-17.717333C458.4 375.914667 482.709333 362.666667 509.482667 362.666667 552.277333 362.666667 586.666667 396.266667 586.666667 437.333333s-34.4 74.666667-77.194667 74.666667a32 32 0 0 0-32 32v64a32 32 0 0 0 64 0v-35.584C603.946667 558.197333 650.666667 503.232 650.666667 437.333333c0-76.757333-63.381333-138.666667-141.194667-138.666666z" fill="#1296db" p-id="5584"></path>
                  </svg>
                </a>
                <el-select 
                  v-model="form.dirId" 
                  placeholder="选择文档目录"
                  style="width: 90%"
                  clearable
                  @change="handleDirChange"
                >
                  <el-option 
                    v-for="dir in dirs"
                    :key="dir.id"
                    :label="dir.name"
                    :value="dir.id"
                  />
                </el-select>       
              </el-form-item>
            </el-col>
          </el-row>      
          <el-form-item label="文档描述">
            <el-input 
              type="textarea" 
              v-model="form.description" 
              :rows="2"
              placeholder="请输入文档描述（可选）"
              maxlength="200"
              show-word-limit
            />
          </el-form-item>
          
          <el-form-item label="文档作者(用户名)">
            <span>{{saveAsForm.docAuthor}}</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel_editor" :disabled="submitting">取 消</el-button>
          <el-button 
            type="primary" 
            @click="submitForm_editor"
            :loading="submitting"       
          >
            {{ submitting ? '提交中...' : '确 定' }}
          </el-button>
        </div>
      </el-dialog>   
      
    <!-- 新建/编辑图文文档对话框 -->
    <el-dialog
      title="图文编辑器"
      :visible.sync="open_editor"
      width="95%"
      top="2vh"
      append-to-body
      :close-on-click-modal="false"
      custom-class="editor-dialog"
      @opened="onEditorDialogOpened"
    >
      <AnythingllmRichEditor
        v-if="open_editor"
        ref="editorComponent"
        :key="editorKey"
        :edit-data="currentEditDoc"
        :default-dir-id="defaultDirId"
        :userName="userName"
        :tenantId="tenantId"
        @save-success="handleEditorSaveSuccess"
      />
    </el-dialog>   


  <!-- 另存为对话框 -->
  <el-dialog
    v-if="saveAsDialogVisible"
    title="另存为"
    :visible.sync="saveAsDialogVisible"
    width="700px"
    top="5vh"
    append-to-body
    :close-on-click-modal="false"
    custom-class="save-as-dialog"
    @close="resetSaveAsForm"
  >
    <el-form 
      :model="saveAsForm" 
      :rules="saveAsRules" 
      ref="saveAsFormRef" 
      label-width="100px"
      class="save-as-form"
    >
      <div class="form-content">
        <!-- 基本文档信息区域 -->
        <div class="form-section">
          <h4 class="section-title">新文档信息</h4>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="文档标题" prop="title">
                <el-input 
                  v-model="saveAsForm.title" 
                  placeholder="请输入新文档标题"
                  maxlength="100"
                  show-word-limit
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="保存目录" prop="dirId">
                <div class="dir-select-wrapper">
                  <el-select 
                    v-model="saveAsForm.dirId" 
                    placeholder="选择保存目录"
                    style="width: 100%"
                    clearable
                    filterable
                  >
                    <el-option 
                      v-for="dir in dirs"
                      :key="dir.id"
                      :label="dir.name"
                      :value="dir.id"
                    />
                  </el-select>
      
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="文档作者">
                <span>{{saveAsForm.docAuthor}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-form-item label="文档描述">
            <el-input 
              type="textarea" 
              v-model="saveAsForm.description" 
              :rows="3"
              placeholder="请输入文档描述（可选）"
              maxlength="200"
              show-word-limit
              resize="none"
            />
          </el-form-item>
        </div>
        
        <!-- 源文档信息区域 -->
        <div class="form-section source-doc-section">
          <h4 class="section-title">源文档信息</h4>
          <div class="source-doc-info">
            <div class="info-grid">
              <div class="info-item">
                <span class="info-label">文档标题：</span>
                <span class="info-value" :title="currentEditDoc?.title || form.title">
                  {{ currentEditDoc?.title || form.title || '未命名文档' }}
                </span>
              </div>
              
              <div class="info-item">
                <span class="info-label">所在目录：</span>
                <span class="info-value" :title="getDirName(currentEditDoc?.dirId || form.dirId)">
                  {{ getDirName(currentEditDoc?.dirId || form.dirId) }}
                </span>
              </div>
              
              <div class="info-item">
                <span class="info-label">文档作者：</span>
                <span class="info-value">
                  {{ currentEditDoc?.docAuthor || saveAsForm.docAuthor || '未设置' }}
                </span>
              </div>
              
              <div class="info-item">
                <span class="info-label">内容统计：</span>
                <span class="info-value">
                  <el-tag size="mini" type="info">{{ wordCount }} 字</el-tag>
                  <el-tag size="mini" type="info" style="margin-left: 5px;">
                    {{ imageCount }} 张图片
                  </el-tag>
                </span>
              </div>
              
              <div v-if="currentEditDoc?.description" class="info-item full-width">
                <span class="info-label">原描述：</span>
                <span class="info-value desc-text" :title="currentEditDoc.description">
                  {{ currentEditDoc.description }}
                </span>
              </div>
              
              <div v-if="currentEditDoc?.createdAt" class="info-item">
                <span class="info-label">创建时间：</span>
                <span class="info-value">
                  {{ formatDate(currentEditDoc.createdAt) }}
                </span>
              </div>
              
              <div v-if="currentEditDoc?.updatedAt" class="info-item">
                <span class="info-label">最后更新：</span>
                <span class="info-value">
                  {{ formatDate(currentEditDoc.updatedAt) }}
                </span>
              </div>
            </div>
            
            <!-- 预览按钮 -->
            <div class="preview-action">
              <el-button 
                type="text" 
                size="small" 
                icon="el-icon-view"
                @click="previewSourceContent"
              >
                预览源文档内容
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button 
        @click="saveAsDialogVisible = false" 
        :disabled="saveAsSubmitting"
        size="medium"
      >
        取 消
      </el-button>
      <el-button 
        type="primary" 
        @click="submitSaveAs"
        :loading="saveAsSubmitting"
        size="medium"
      >
        {{ saveAsSubmitting ? '保存中...' : '确 定 保 存' }}
      </el-button>
    </div>
  </el-dialog>
    </div>
  </div>
</template>
 
<script>
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import ImageLibrarySelector from '@/components/aics/ImageLibrarySelector.vue'
import { listBriefDirsByTenantid  } from '@/api/aics/KbDocument';
import { createEditorDoc, updateEditorDoc,getEditorDocWithRefreshedImages } from '@/api/aics/kbDocRichEditor'
//import { Col } from 'element-ui'

// HTML转Markdown函数
const htmlToMarkdown = (html) => {
  if (!html) return ''
  
  let markdown = html
  
  // 处理所有图片 - 使用唯一的标记符
  //let imgIndex = 0
  markdown = markdown.replace(/<img[^>]*src="([^"]*)"[^>]*alt="([^"]*)"[^>]*>/g, 
    (match, src, alt) => {
    //  imgIndex++
      
      // 提取纯净的相对路径
      const cleanUrl = extractCleanImageUrl(src)
      const normalizedUrl = cleanUrl.includes('image-library/') 
        ? cleanUrl 
        : `image-library/${cleanUrl}`
      
      return `![${alt || '图片'}](${normalizedUrl})`
    })
  
  // 处理没有alt属性的图片
  markdown = markdown.replace(/<img[^>]*src="([^"]*)"[^>]*>/g, 
    (match, src) => {
      //imgIndex++
      
      const cleanUrl = extractCleanImageUrl(src)
      const normalizedUrl = cleanUrl.includes('image-library/') 
        ? cleanUrl 
        : `image-library/${cleanUrl}`
      
      return `![图片](${normalizedUrl})`
    })
  
  // 原有的其他转换规则
  const rules = [
    // 标题
    { regex: /<h1[^>]*>(.*?)<\/h1>/g, replacement: '# $1\n\n' },
    { regex: /<h2[^>]*>(.*?)<\/h2>/g, replacement: '## $1\n\n' },
    { regex: /<h3[^>]*>(.*?)<\/h3>/g, replacement: '### $1\n\n' },
    
    // 粗体和斜体
    { regex: /<strong[^>]*>(.*?)<\/strong>/g, replacement: '**$1**' },
    { regex: /<b[^>]*>(.*?)<\/b>/g, replacement: '**$1**' },
    { regex: /<em[^>]*>(.*?)<\/em>/g, replacement: '*$1*' },
    { regex: /<i[^>]*>(.*?)<\/i>/g, replacement: '*$1*' },
    
    // 链接
    { regex: /<a[^>]*href="([^"]*)"[^>]*>(.*?)<\/a>/g, replacement: '[$2]($1)' },
    
    // 列表
    { 
      regex: /<ul[^>]*>(.*?)<\/ul>/gs, 
      replacement: (match, p1) => {
        return p1.replace(/<li[^>]*>(.*?)<\/li>/g, '- $1\n') + '\n'
      }
    },
    { 
      regex: /<ol[^>]*>(.*?)<\/ol>/gs, 
      replacement: (match, p1) => {
        let counter = 1
        return p1.replace(/<li[^>]*>(.*?)<\/li>/g, () => `${counter++}. $1\n`) + '\n'
      }
    },
    
    // 段落和换行
    { regex: /<p[^>]*>(.*?)<\/p>/g, replacement: '$1\n\n' },
    { regex: /<br\s*\/?>/g, replacement: '\n' },
    { regex: /<div[^>]*>(.*?)<\/div>/g, replacement: '$1\n' },
    
    // 移除其他标签
    { regex: /<[^>]*>/g, replacement: '' },
    
    // 清理空白字符
    { regex: /&nbsp;/g, replacement: ' ' },
    { regex: /&amp;/g, replacement: '&' },
    { regex: /&lt;/g, replacement: '<' },
    { regex: /&gt;/g, replacement: '>' },
    { regex: /&quot;/g, replacement: '"' },
    
    // 规范化空行
    { regex: /\n{3,}/g, replacement: '\n\n' },
    { regex: /[ \t]+\n/g, replacement: '\n' }
  ]
  
  rules.forEach(rule => {
    markdown = markdown.replace(rule.regex, rule.replacement)
  })
  
  return markdown.trim()
}

// 提取干净的图片URL
const extractCleanImageUrl = (url) => {
  if (!url) return ''
  
  try {
    // 移除URL参数
    let cleanUrl = url.split('?')[0]
    
    // 如果包含OSS域名，提取相对路径
    if (cleanUrl.includes('oss-cn-') || cleanUrl.includes('aliyuncs.com')) {
      const urlObj = new URL(cleanUrl)
      const pathParts = urlObj.pathname.split('/')
      
      // 查找 image-library 目录
      const imageLibIndex = pathParts.indexOf('image-library')
      if (imageLibIndex !== -1) {
        // 提取 image-library 之后的部分
        return pathParts.slice(imageLibIndex).join('/')
      }
      
      // 如果找不到，返回最后两部分
      if (pathParts.length >= 2) {
        return pathParts.slice(-2).join('/')
      }
    }
    
    return cleanUrl
    
  } catch (error) {
    // 返回原始URL，去除参数
    return url.split('?')[0]
  }
}

export default {
  name: 'AnythingllmRichEditor',
  components: {
    quillEditor,
    ImageLibrarySelector
  },
  props: {
    // 编辑现有文档时传入
    editData: {
      type: Object,
      default: null
    },
    // 默认目录ID
    defaultDirId: {
      type: Number,
      default: null
    },
    // 目录列表
    dirList: {
      type: Array,
      default: () => []
    },
    tenantId: {
      type: Number,
      default: 0
    },
    userName: {
      type: String,
       default: ''
    },
    workspaceSlug:{
      type: String,
       default: ''      
    }
  },
  data() {
    return {
      form: {
        title: '',
        dirId: null,
        description: '',
        docAuthor: 'admin',
        htmlContent: '',
        markdownContent: '',
        imageReferences: [],
        currentEditDoc: null,
          storedWorkspaceSlug: '',  // 存储传递的 workspaceSlug
        editorKey: 0,
        originalContent: '',
      },
      dirs: [],
      rules: {
        title: [
          { required: true, message: '请输入文档标题', trigger: 'blur' },
          { min: 1, max: 100, message: '标题长度在 1 到 100 个字符', trigger: 'blur' }
        ],
        dirId: [
          { required: true, message: '请选择文档目录', trigger: 'change' }
        ]
      },
      // 编辑器相关
      quill: null,
      showStatus: true,
      showPreview: false,
      imagePickerVisible: false,
      selectedImage: null,
      open_editor_baseinfo: false,
      submitting: false,
      editorHasContent: false,
      
    // 图文编辑器相关
    open_editor: false,
    editorDialogTitle: '新建图文文档',      
    currentEditDoc: null,
    editorDirList: [],
      // 编辑器配置
      editorOptions: {
        modules: {
          toolbar: {
            container: [
              // 字体样式
              ['bold', 'italic', 'underline'],
              // 标题
              [{ 'header': [1, 2, 3, false] }],
              // ⭐ 注释掉或删除下面这一行，即可移除有序列表和无序列表按钮
              // [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              
              // 缩进
              [{ 'indent': '-1'}, { 'indent': '+1' }],
              // 对齐
              [{ 'align': [] }],
              // 链接和图片
              ['link', 'image'],
              // 颜色
              [{ 'color': [] }, { 'background': [] }],
              // 清除格式
              ['clean']
            ],
            handlers: {
              'image': this.handleInsertImage
            }
          }
        },
        placeholder: '开始编写您的文档内容...',
        theme: 'snow',
        scrollingContainer: '.quill-editor'
      },
  // 另存为相关数据
          saveAsDialogVisible: false,
          saveAsSubmitting: false,
          saveAsForm: {
            id: 0,
            title: '',
            dirId: null,
            description: '',
            docAuthor: ''
          },
          saveAsRules: {
            title: [
              { required: true, message: '请输入新文档标题', trigger: 'blur' },
              { min: 1, max: 100, message: '标题长度在 1 到 100 个字符', trigger: 'blur' }
            ],
            dirId: [
              { required: true, message: '请选择保存目录', trigger: 'change' }
            ]
          },
    // 是否有选中的图片
      hasSelectedImage: false,
      // 选中的图片元素
      selectedImageElement: null,
      
      // 按钮高亮样式
      buttonHighlightStyle: {
        active: false,
        timer: null
      },
      
     lastSetContent: null,
      setContentStack: null,     
    }
  },


  computed: {
 // 文档显示标题
  documentDisplayTitle() {
    if (this.currentEditDoc && this.currentEditDoc.title) {
      return this.currentEditDoc.title;
    }
    
    if (this.form.title && this.form.title.trim()) {
      return this.form.title;
    }
    
    return '未命名文档';
  },
  
  // 保存状态
  saveStatus() {
    if (this.submitting || this.saveAsSubmitting) {
      return 'saving';
    } else if (this.currentEditDoc && this.currentEditDoc.id) {
      return 'saved';
    } else if (this.form.htmlContent && this.form.htmlContent.trim()) {
      return 'unsaved';
    } else {
      return 'empty';
    }
  },
  
  saveStatusText() {
    switch (this.saveStatus) {
      case 'saving': return '保存中...';
      case 'saved': return '已保存';
      case 'unsaved': return '未保存';
      default: return '空文档';
    }
  },    
      // 编辑器容器高度
    editorContainerHeight() {
      if (this.autoHeight && this.actualHeight) {
        return `${this.actualHeight}px`;
      }
      
      if (typeof this.containerHeight === 'number') {
        return `${this.containerHeight}px`;
      }
      
      return this.containerHeight;
    },
    // 字数统计
    wordCount() {
      if (!this.form.htmlContent) return 0
      const text = this.form.htmlContent.replace(/<[^>]*>/g, '')
      return text.length
    },
    // 图片数量统计
    imageCount() {
      if (!this.form.htmlContent) return 0
      const imgMatches = this.form.htmlContent.match(/<img[^>]*>/g)
      return imgMatches ? imgMatches.length : 0
    }
  },
  watch: {
      workspaceSlug: {
    immediate: true,
    handler(newVal) {
      console.log('【EDITOR】workspaceSlug 直接监听:', newVal);
      // 存储到 data 中，避免被覆盖
      this.storedWorkspaceSlug = newVal;
     }
    },
    editData: {
      handler(newVal, oldVal) {
         console.log('【EDITOR】editData 变化，workspaceSlug:', this.workspaceSlug);
        console.log('【EDITOR】watch editData 触发:', {
          newVal: newVal,
          oldVal: oldVal,
          hasNewData: !!newVal,
          hasOldData: !!oldVal,
          isSameData: this.currentEditDoc?.id === newVal?.id
        });
        
        // 关键修改：只要有新数据就加载，无论是否相同
        if (newVal) {
          console.log('【EDITOR】有编辑数据，开始加载');
          this.loadEditData(newVal);
        } else {
          console.log('【EDITOR】无编辑数据，重置表单');
          this.resetForm();
        }
      },
      immediate: true,
      deep: true
    },
    defaultDirId: {
      handler(newVal) {
        console.log("defaultDirId",newVal)
        if (newVal && !this.form.dirId) {
          this.form.dirId = newVal
        }
      },
      immediate: true
    },
  },
  mounted() {
    console.log('【EDITOR】组件已挂载');
    
    this.loadCategories();
    
    if (this.userName && !this.form.docAuthor) {
      this.form.docAuthor = this.userName;
    }
    
    // ★★★ 添加定期检查，防止内容被意外清空 ★★★
    this.contentCheckTimer = setInterval(() => {
      if (this.form.htmlContent && this.quill) {
        const currentContent = this.quill.root.innerHTML;
        if (!currentContent || currentContent.trim() === '') {
          console.warn('【EDITOR】检测到内容被清空，尝试恢复');
          this.setEditorContent();
        }
      }
    }, 500);  // 每500ms检查一次
    
    // 5秒后停止检查
    setTimeout(() => {
      if (this.contentCheckTimer) {
        clearInterval(this.contentCheckTimer);
        this.contentCheckTimer = null;
      }
    }, 5000);
  },

// 在 beforeDestroy 中清理
beforeDestroy() {
  if (this.contentCheckTimer) {
    clearInterval(this.contentCheckTimer);
    this.contentCheckTimer = null;
  }
},
  methods: {
    startContentDebugging() {
        // 拦截 form.htmlContent 的所有修改
        const self = this;
        const originalForm = this.form;
        
        // 使用 Proxy 监控 form 对象
        if (!this._formProxy) {
          this._formProxy = new Proxy(originalForm, {
            set(target, property, value) {
              if (property === 'htmlContent') {
                console.group('🔴 htmlContent 被修改');
                console.log('新值:', value ? value.substring(0, 200) : '(空)');
                console.log('旧值:', target.htmlContent ? target.htmlContent.substring(0, 200) : '(空)');
                console.log('调用栈:', new Error().stack);
                console.groupEnd();
                
                // 记录最后一次修改
                self.lastSetContent = value;
                self.setContentStack = new Error().stack;
              }
              target[property] = value;
              return true;
            }
          });
          this.form = this._formProxy;
        }
      },    
    loadCategories() {
        console.log("开始加载目录列表...");
        listBriefDirsByTenantid(this.tenantId).then(res => {
          console.log("目录列表API返回:", res);
          console.log("原始目录数据:", res.data.data);
          this.dirs = res.data.data;
        });
      },

       // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '未知';
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (e) {
        return dateString;
      }
    },
    // 预览源文档内容
    previewSourceContent() {
      if (!this.form.htmlContent) {
        this.$message.warning('源文档内容为空');
        return;
      }
      
      this.$alert(
        `<div class="source-preview">${this.form.htmlContent}</div>`,
        '源文档内容预览',
        {
          dangerouslyUseHTMLString: true,
          customClass: 'source-preview-dialog',
          showConfirmButton: false,
          closeOnClickModal: true,
          width: '80%',
          beforeClose: (action, instance, done) => {
            if (action === 'cancel') {
              done();
            }
          }
        }
      );
    },    
    // 编辑器准备就绪
onEditorReady(quill) {
  this.quill = quill;
  
  console.log('【EDITOR】编辑器就绪');
  
  // ★★★ 立即锁定，并且锁定时间更长 ★★★
  this.isSettingContent = true;
  
  // 延迟设置内容，确保编辑器完全初始化
  setTimeout(() => {
    if (this.form.htmlContent && this.form.htmlContent.trim()) {
      console.log('【EDITOR】延迟设置实际内容');
      this.setEditorContent();
    }
    // ★★★ 延长锁定时间到 3 秒，确保所有 Quill 初始化事件都完成 ★★★
    setTimeout(() => {
      this.isSettingContent = false;
      console.log('【EDITOR】编辑器初始化完成，解除锁定');
    }, 3000);
  }, 500);
  
  // 监听编辑器点击事件
  quill.root.addEventListener('click', (event) => {
    if (event.target.tagName === 'IMG') {
      this.selectImage(event.target);
      event.stopPropagation();
      event.preventDefault();
      return false;
    } else {
      if (!event.target.closest('.highlight-button')) {
        this.clearImageSelection();
      }
    }
  });
  
  // 监听Quill的选择变化
  quill.on('selection-change', (range, oldRange, source) => {
    if (range && range.length > 0 && source === 'user') {
      const selectedContent = quill.getContents(range.index, range.length);
      const hasImage = selectedContent.ops.some(op => op.insert && op.insert.image);
      
      if (!hasImage && this.hasSelectedImage) {
        setTimeout(() => {
          this.clearImageSelection();
        }, 0);
      }
    }
  });
  
  // ★★★ 移除测试代码，避免干扰 ★★★
  // 注释掉或删除以下测试代码：
  /*
  setTimeout(() => {
    quill.insertText(0, '测试列表项');
    quill.setSelection(0, 6);
    quill.format('list', 'ordered');
    console.log('手动应用 ordered list 后的格式:', quill.getFormat());
    console.log('编辑器 HTML:', quill.root.innerHTML);
    quill.setText('');
  }, 500);
  */
},
    // 在组件销毁前清理
    beforeDestroy() {
      this.removeClickOutsideListener();
      this.removeKeyboardListener();
      
      if (this.quill) {
        this.quill.off('selection-change');
      }
    },    
    // 选中图片的方法
    selectImage(imgElement) {
      // 清除之前的选中状态
      this.clearImageSelection();
      
      // 设置选中状态
      this.selectedImageElement = imgElement;
      this.hasSelectedImage = true;
      
      // 添加选中样式
      imgElement.classList.add('selected');
      imgElement.style.outline = '2px solid #409EFF';
      imgElement.style.boxShadow = '0 0 5px rgba(64, 158, 255, 0.5)';
      
      console.log('图片已选中:', imgElement.src);
      
      // 关键：确保编辑器焦点在图片上
      this.focusOnImage(imgElement);
      
      // 添加按钮高亮效果
      this.highlightResizeButton();
      
      // 监听编辑器点击，点击其他地方取消选中
      this.setupClickOutsideListener();
      
      // 监听键盘事件
      this.setupKeyboardListener();
    },

  // 聚焦到图片上
  focusOnImage(imgElement) {
    if (!this.quill) return;
    
    try {
      // 获取图片在编辑器中的位置
      //const editor = this.quill.root;
      const range = document.createRange();
      const selection = window.getSelection();
      
      // 设置range为图片之前的位置
      range.selectNode(imgElement);
      range.collapse(false); // true: 在图片前，false: 在图片后
      
      // 清除所有选择
      selection.removeAllRanges();
      
      // 设置新的选择
      selection.addRange(range);
      
      // 更新Quill的选择
      const index = this.getImageIndexInQuill(imgElement);
      if (index !== -1) {
        this.quill.setSelection(index, 1, 'user'); // 选中图片（长度为1）
      }
      
    } catch (error) {
      console.warn('聚焦图片失败:', error);
    }
  },

    // 获取图片在Quill中的索引
    getImageIndexInQuill(imgElement) {
      if (!this.quill) return -1;
      
      const editor = this.quill.root;
      const images = editor.querySelectorAll('img');
      
      // 计算imgElement在编辑器中的总位置
      let totalIndex = 0;
      //const editorText = editor.textContent || '';
      
      // 简化的方法：遍历Quill的delta来找到图片
      try {
        const delta = this.quill.getContents();
        for (let i = 0; i < delta.ops.length; i++) {
          const op = delta.ops[i];
          
          // 如果是图片嵌入
          if (op.insert && op.insert.image) {
            const currentImg = images[0];
            if (currentImg === imgElement) {
              return totalIndex;
            }
            images.shift();
          }
          
          // 增加索引
          if (op.insert) {
            if (typeof op.insert === 'string') {
              totalIndex += op.insert.length;
            } else if (op.insert.image) {
              totalIndex += 1; // 图片占一个位置
            }
          }
        }
      } catch (error) {
        console.warn('获取图片索引失败，使用DOM方法:', error);
        
        // 备用方法：使用DOM遍历
        const walker = document.createTreeWalker(
          editor,
          NodeFilter.SHOW_ELEMENT,
          null,
          false
        );
        
        let node;
        let index = 0;
        while (node == walker.nextNode()) {
          if (node === imgElement) {
            return index;
          }
          if (node.nodeType === Node.ELEMENT_NODE) {
            index += 1;
          }
        }
      }
      
      return -1;
    },
    // 清除所有图片的选中状态
    clearImageSelection() {
      const allImages = this.$el.querySelectorAll('.ql-editor img');
      allImages.forEach(img => {
        img.classList.remove('selected');
        img.style.outline = '';
        img.style.boxShadow = '';
      });
      
      this.selectedImageElement = null;
      this.hasSelectedImage = false;
      
      // 移除按钮高亮
      this.removeResizeButtonHighlight();
      
      // 移除点击监听
      this.removeClickOutsideListener();
      
      // 移除键盘监听
      this.removeKeyboardListener();
    },
    // 内容变化处理
    onContentChange(formData) {
    // ★★★ 最严格的保护：只要 isSettingContent 为 true，完全忽略 ★★★
    if (this.isSettingContent) {
      console.log('【EDITOR】忽略内容变化（正在设置内容中）');
      return;
    }
    
    // 检查 formData 是否有效
    if (!formData) {
      return;
    }
    
    // 获取实际内容
    const newContent = formData.htmlContent || '';
    const oldContent = this.form.htmlContent || '';
    
    // ★★★ 如果新内容为空但旧内容不为空，很可能是 Quill 的初始化事件，忽略 ★★★
    if (!newContent && oldContent) {
      console.log('【EDITOR】忽略空内容变化（可能是初始化事件）');
      return;
    }
    
    // 如果新旧内容相同，不需要更新
    if (newContent === oldContent) {
      console.log('【EDITOR】内容未变化，跳过');
      return;
    }
    
    console.log('【EDITOR】内容变化:', {
      oldLength: oldContent.length,
      newLength: newContent.length
    });
    
    // 更新内容
    this.form.htmlContent = newContent;
    this.convertToMarkdown();
    this.$emit('content-change', { ...this.form });
    this.editorHasContent = !!newContent;
  },
    // 高亮调整大小按钮
  highlightResizeButton() {
    // 清除之前的定时器
    if (this.buttonHighlightStyle.timer) {
      clearInterval(this.buttonHighlightStyle.timer);
    }
    
    // 设置高亮状态
    this.buttonHighlightStyle.active = true;
    
    // 添加脉冲动画效果
    let pulseCount = 0;
    this.buttonHighlightStyle.timer = setInterval(() => {
      pulseCount++;
      if (pulseCount > 6) { // 脉冲6次后停止
        clearInterval(this.buttonHighlightStyle.timer);
        this.buttonHighlightStyle.timer = null;
      }
    }, 500);
  },

  // 移除按钮高亮
  removeResizeButtonHighlight() {
    this.buttonHighlightStyle.active = false;
    if (this.buttonHighlightStyle.timer) {
      clearInterval(this.buttonHighlightStyle.timer);
      this.buttonHighlightStyle.timer = null;
    }
  },



   // HTML转Markdown


    convertToMarkdown() {
      // 在转换前处理图片大小属性
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = this.form.htmlContent
      
      // 处理所有图片
      const images = tempDiv.querySelectorAll('img')
      images.forEach(img => {
        if (img.style.width || img.style.height) {
          // 确保样式被保留
          img.style.width = img.style.width || `${img.width}px`
          img.style.height = img.style.height || `${img.height}px`
        }
      })
      
      this.form.htmlContent = tempDiv.innerHTML
        
      const newMarkdown = htmlToMarkdown(this.form.htmlContent)
      this.form.markdownContent = newMarkdown
    },
    
    // 目录变更
    handleDirChange(dirId) {
      console.log('选择的目录ID:', dirId)
      this.$emit('dir-change', dirId)
    },
    // 添加验证方法
    validateContent() {
      const errors = [];
      
      // 验证字数
      if (this.wordCount > 5000) {
        errors.push(`文档字数(${this.wordCount})超过限制(5000字)`);
      }
      
      // 验证图片数量
      if (this.imageCount > 5) {
        errors.push(`文档图片数量(${this.imageCount})超过限制(50张)`);
      }
      
      return {
        isValid: errors.length === 0,
        errors: errors
      };
    },
    
    // 保存文档
    handleSave() {
  // 先验证内容
  const validation = this.validateContent();
  if (!validation.isValid) {
    this.$message.error(validation.errors.join('；'));
    return false;
  }

      if (!this.form.htmlContent || this.form.htmlContent.trim() === '') {
        this.$message.warning('请输入文档内容');
        return false;
      }
      
      // 检查标题
      if (!this.form.title || this.form.title.trim() === '') {
        console.log('【EDITOR】标题为空，打开基本信息对话框');
        
        // 确保有目录选择
        if (!this.form.dirId && this.dirs.length > 0) {
          this.form.dirId = this.dirs[0].id;
          console.log('【EDITOR】自动设置目录ID为第一个:', this.form.dirId);
        }
        
        this.open_editor_baseinfo = true;
      } else {
        this.submitForm_editor();
      }
    },
    onEditorDialogOpened() {
      console.log('编辑器对话框已打开，强制重新渲染');
      this.editorKey = Date.now();
    },    
    // 取消编辑
    cancel_editor() {
      this.open_editor_baseinfo = false
    },
    
    // 提交图文文档
async submitForm_editor() {
  try {
    this.submitting = true
    
    // 验证表单
    if (!this.form.title || this.form.title.trim() === '') {
      this.$message.error('请输入文档标题');
      this.submitting = false;
      return;
    }
    
    // 检查目录
    if (!this.form.dirId) {
      this.$message.error('请选择文档目录');
      this.submitting = false;
      return;
    }
    
    // 清理重复的图片引用
    const cleanImageReferences = () => {
      if (!this.form.imageReferences || !Array.isArray(this.form.imageReferences)) {
        return [];
      }
      
      // 1. 基于 objectKey 去重
      const seen = new Set();
      const uniqueRefs = this.form.imageReferences.filter(ref => {
        if (!ref || !ref.objectKey) return false;
        if (seen.has(ref.objectKey)) return false;
        seen.add(ref.objectKey);
        return true;
      });
      
      // 2. 只保留内容中实际存在的图片
      const contentObjectKeys = this.extractImageObjectKeysFromContent(this.form.htmlContent);
      return uniqueRefs.filter(ref => 
        ref.objectKey && contentObjectKeys.includes(ref.objectKey)
      );
    };
    
    // 从HTML内容中提取所有图片的objectKey
    this.extractImageObjectKeysFromContent = (htmlContent) => {
      if (!htmlContent) return [];
      const objectKeys = [];
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlContent;
      
      const images = tempDiv.querySelectorAll('img');
      images.forEach(img => {
        if (img.src) {
          const objectKey = this.extractObjectKeyFromUrl(img.src);
          if (objectKey) objectKeys.push(objectKey);
        }
      });
      
      return objectKeys;
    };
    
    // 构建表单数据
    const formData = await this.getFormData();
    if (!formData) {
      this.submitting = false;
      return;
    }
    
    // 清理图片引用
    const cleanedImageReferences = cleanImageReferences();
    console.log('清理前图片引用数量:', this.form.imageReferences?.length || 0);
    console.log('清理后图片引用数量:', cleanedImageReferences.length);

    // 准备API请求数据
    const uploadRequest = {
      id: this.currentEditDoc?.id || 0,
      title: formData.title,
      dirId: formData.dirId,
      description: formData.description || '',
      docAuthor: formData.docAuthor || this.userName,
      htmlContent: formData.htmlContent,
      markdownContent: formData.markdownContent || '',
      imageReferences: cleanedImageReferences, // 使用清理后的引用
      wordCount: formData.wordCount ||0,
      imageCount: cleanedImageReferences.length || 0, // 更新为实际数量
      workspaceSlug: this.workspaceSlug,
      metadata: {
        title: formData.title || '未命名文档',
        author: formData.docAuthor,
        description: formData.description
      }  
    };
    
    console.log('提交文档数据:', uploadRequest);
    
    let res;
    if (this.currentEditDoc) {
      res = await updateEditorDoc(this.currentEditDoc.id, uploadRequest);
    } else {
      res = await createEditorDoc(uploadRequest);
    }

    if (res.data.code === 200) {
      this.$message.success(this.currentEditDoc ? '更新成功' : '创建成功');
      this.open_editor_baseinfo = false;
      this.editorHasContent = true;
      
      // 更新本地图片引用为清理后的版本
      this.form.imageReferences = cleanedImageReferences;
      
      // 触发保存成功事件
      this.$emit('save-success', res.data.data);
      
    } else if (res.data.code === 500 && res.data.message && 
              res.data.message.includes('已存在标题为')) {
      this.$message.error(res.data.message);
      this.open_editor_baseinfo = true;
    } else {
      this.$message.error(res.data.message || '操作失败');
    }
  } catch (error) {
    console.error('提交文档失败:', error);
    this.$message.error('提交文档失败');
  } finally {
    this.submitting = false;
  }
},
    
    // 插入图片
    handleInsertImage() {
      this.imagePickerVisible = true
      this.selectedImage = null
    },
    
    // 图片选择回调
    handleImageSelected(selectedImage) {
      if (!selectedImage) {
        this.$message.error('图片选择失败')
        return
      }
      
      // 插入图片到编辑器
      this.insertImageToEditor(selectedImage)
      
      // 关闭选择器
      this.imagePickerVisible = false
      
      this.$message.success('图片插入成功')
    },
    
    // 取消图片选择
    handleImagePickerCancel() {
      this.imagePickerVisible = false
      this.selectedImage = null
    },
    
    // 插入图片到编辑器
    insertImageToEditor(image) {
      if (!this.quill) {
        console.error('Quill编辑器未初始化')
        return
      }
      
      const range = this.quill.getSelection()
      const position = range ? range.index : 0
      
      // 获取图片URL
      let imageUrl = image.temp_url || image.tempUrl || image.url || image.imageUrl
      
      if (!imageUrl) {
        console.error('找不到有效的图片URL:', image)
        this.$message.error('图片URL无效')
        return
      }
      
      // 插入图片到编辑器
      this.quill.insertEmbed(position, 'image', imageUrl)
      this.quill.setSelection(position + 1)
      
      // 确保图片引用被正确记录
      if (!this.form.imageReferences) {
        this.form.imageReferences = []
      }
      
      // 提取objectKey
      const objectKey = this.extractObjectKeyFromUrl(imageUrl)
      
      // 构建图片引用对象
      const imageRef = {
        imageId: image.id || 0,
        altText: image.name || image.originalFilename || '图片',
        objectKey: objectKey,
        tempUrl: imageUrl,
        position: position
      }
      
      this.form.imageReferences.push(imageRef)
      
      // 立即更新Markdown内容
      setTimeout(() => {
        this.convertToMarkdown()
      }, 100)
    },
    
    // 切换预览模式
    togglePreview() {
      this.showPreview = !this.showPreview
    },
    
    // 清除格式
    handleClearFormat() {
      if (!this.quill) return
      
      const range = this.quill.getSelection()
      if (range) {
        if (range.length === 0) {
          // 没有选中文本，清除整个编辑器格式
          this.quill.removeFormat(0, this.quill.getLength())
        } else {
          // 清除选中文本的格式
          this.quill.removeFormat(range.index, range.length)
        }
        this.$message.success('格式已清除')
      }
    },
    
    // 加载编辑数据
    async loadEditData(data) {
    console.log('【EDITOR】开始加载编辑数据');
    
    try {
      // ★★★ 不要在 loadEditData 中设置锁定，让 onEditorReady 来控制 ★★★
      
      const promiseResult = getEditorDocWithRefreshedImages(data.id);
      const res = await promiseResult;
      
      const apiData = res.data?.data || res.data;
      
      const formattedData = {
        title: apiData.title || data.title || '',
        dirId: apiData.dirId || data.dirId || this.defaultDirId || null,
        description: apiData.description || data.description || '',
        docAuthor: apiData.docAuthor || data.docAuthor || this.userName || 'admin',
        htmlContent: apiData.editorContent || apiData.htmlContent || apiData.html_content || data.htmlContent || data.html_content || '',
        markdownContent: apiData.markdownContent || apiData.markdown_content || data.markdownContent || data.markdown_content || '',
        imageReferences: apiData.imageReferences || apiData.image_references || data.imageReferences || data.image_references || []
      };
      
      console.log('【EDITOR】格式化后的数据，htmlContent长度:', formattedData.htmlContent?.length);
      
      // ★★★ 先设置表单数据，但不设置 htmlContent ★★★
      this.form.title = formattedData.title;
      this.form.dirId = formattedData.dirId;
      this.form.description = formattedData.description;
      this.form.docAuthor = formattedData.docAuthor;
      this.form.markdownContent = formattedData.markdownContent;
      this.form.imageReferences = formattedData.imageReferences;
      
      // ★★★ 最后设置 htmlContent，这样 Quill 的 v-model 会最后响应 ★★★
      this.form.htmlContent = formattedData.htmlContent;
      
      this.currentEditDoc = data;
      this.editorHasContent = !!formattedData.htmlContent;
      
      // ★★★ 不在这里调用 setEditorContent，让 onEditorReady 来处理 ★★★
      
    } catch (error) {
      console.error('【EDITOR】加载编辑数据失败:', error);
      // 使用原始数据
      const formattedData = {
        title: data.title || '',
        dirId: data.dirId || data.dir_id || this.defaultDirId || null,
        description: data.description || '',
        docAuthor: data.docAuthor || data.doc_author || this.userName || 'admin',
        htmlContent: data.htmlContent || data.html_content || data.editorContent || '',
        markdownContent: data.markdownContent || data.markdown_content || '',
        imageReferences: data.imageReferences || data.image_references || []
      };
      
      this.form.title = formattedData.title;
      this.form.dirId = formattedData.dirId;
      this.form.description = formattedData.description;
      this.form.docAuthor = formattedData.docAuthor;
      this.form.markdownContent = formattedData.markdownContent;
      this.form.imageReferences = formattedData.imageReferences;
      this.form.htmlContent = formattedData.htmlContent;
      
      this.editorHasContent = !!formattedData.htmlContent;
    }
  },

// 新增备用方法
useOriginalData(data) {
  console.log('【EDITOR】使用原始数据:', data);
  
  const formattedData = {
    title: data.title || '',
    dirId: data.dirId || data.dir_id || this.defaultDirId || null,
    description: data.description || '',
    docAuthor: data.docAuthor || data.doc_author || this.userName || 'admin',
    htmlContent: data.htmlContent || data.html_content || data.editorContent || '',
    markdownContent: data.markdownContent || data.markdown_content || '',
    imageReferences: data.imageReferences || data.image_references || []
  };
  
  this.form.htmlContent = formattedData.htmlContent;
  this.form.markdownContent = formattedData.markdownContent;
  this.form.title = formattedData.title;
  this.form.dirId = formattedData.dirId;
  this.form.description = formattedData.description;
  this.form.docAuthor = formattedData.docAuthor;
  this.form.imageReferences = formattedData.imageReferences;
  
  this.editorHasContent = !!formattedData.htmlContent;
  
  if (this.quill && formattedData.htmlContent) {
    this.$nextTick(() => {
      this.setEditorContent();
    });
  }
},
 
    testEditorContent() {
      if (!this.quill) return;
      
      console.log('【EDITOR】测试编辑器是否能正常显示内容...');
      
      // 测试1：插入纯文本
      this.quill.setText('');
      this.quill.insertText(0, '测试文本 - 如果这能显示，说明编辑器正常');
      
      setTimeout(() => {
        console.log('【EDITOR】测试文本结果:', {
          text: this.quill.getText(),
          html: this.quill.root.innerHTML
        });
        
        // 测试2：插入简单HTML
        if (this.quill.getText().includes('测试文本')) {
          console.log('【EDITOR】编辑器正常，可以显示文本');
          
          // 测试插入简单图片HTML
          const testHtml = '<p>测试段落</p><p><img src="https://via.placeholder.com/100x50" alt="测试图片"></p>';
          this.quill.setText('');
          this.quill.clipboard.dangerouslyPasteHTML(0, testHtml);
          
          setTimeout(() => {
            console.log('【EDITOR】测试HTML结果:', {
              text: this.quill.getText(),
              html: this.quill.root.innerHTML?.substring(0, 200)
            });
          }, 100);
        } else {
          console.error('【EDITOR】编辑器异常，无法显示测试文本');
        }
      }, 100);
    },   
    // 设置编辑器内容
    setEditorContent() {
      if (!this.quill) {
        console.error('【EDITOR】Quill编辑器未初始化');
        return;
      }
      
      const content = this.form.htmlContent;
      console.log('【EDITOR】尝试设置编辑器内容，内容长度:', content?.length);
      
      if (!content || content.trim() === '') {
        console.warn('【EDITOR】没有HTML内容可设置');
        return;
      }
      
      try {
        this.isSettingContent = true;
        
        // ★★★ 直接操作 DOM，这是最可靠的方式 ★★★
        const editorElement = this.quill.root;
        
        // 直接设置 innerHTML
        editorElement.innerHTML = content;
        
        // 强制 Quill 更新内部状态
        this.quill.update('silent');
        
        // 确保光标在末尾
        this.quill.setSelection(this.quill.getLength(), 0);
        
        console.log('【EDITOR】内容设置完成');
        console.log('【EDITOR】Quill 内容长度:', this.quill.getLength());
        console.log('【EDITOR】Quill root HTML 前100字符:', this.quill.root.innerHTML.substring(0, 100));
        
      } catch (error) {
        console.error('【EDITOR】设置编辑器内容失败:', error);
      }
    },
    // 解析图片引用数据
    parseImageReferences(imageRefs) {
      if (!imageRefs) {
        return []
      }
      
      try {
        let parsedRefs = imageRefs
        
        // 如果是字符串，解析为JSON
        if (typeof imageRefs === 'string') {
          parsedRefs = JSON.parse(imageRefs)
        }
        
        // 确保是数组
        if (!Array.isArray(parsedRefs)) {
          return []
        }
        
        // 格式化图片引用数据
        return parsedRefs.map((ref, index) => ({
          imageId: ref.imageId || ref.imageld || 0,
          altText: ref.altText || '图片',
          objectKey: ref.objectKey || this.extractObjectKeyFromUrl(ref.tempUrl) || '',
          tempUrl: ref.tempUrl || '',
          position: ref.position || index
        }))
      } catch (error) {
        console.error('解析图片引用失败:', error)
        return []
      }
    },
    
    // 处理图片URL（将存储的图片ID转换为临时URL显示）
    async processImageUrls() {
      if (!this.form.imageReferences || this.form.imageReferences.length === 0) {
        return
      }
      
      // 这里可以添加生成临时URL的逻辑
      // 暂时使用已有的tempUrl
    },
    
    // 从URL提取objectKey
    extractObjectKeyFromUrl(url) {
      if (!url) return ''

      console.log("extractObjectKeyFromUrl url",url)
      try {
        // 如果已经是相对路径，直接返回
        if (url.includes('image-library/') && !url.includes('://')) {
          return url
        }        
        // 解析URL
        const urlObj = new URL(url)
        const pathname = urlObj.pathname
        
        // 提取关键部分
        const pathParts = pathname.split('/')
        
        // 查找包含 image-library 的部分
        const imageLibIndex = pathParts.findIndex(part => part === 'image-library')
        if (imageLibIndex !== -1) {
          // 提取 image-library 之后的部分
          return pathParts.slice(imageLibIndex).join('/')
        }
        
        // 如果找不到 image-library，返回最后两部分
        return pathParts.slice(-2).join('/')
        
      } catch (error) {
        console.error('提取objectKey失败:', error)
        return url
      }
    },
    
    // 获取表单数据（供父组件调用）
    async getFormData() {
      try {
        console.log('【EDITOR】开始获取表单数据，准备验证...');
        console.log('【EDITOR】当前表单数据:', {
          title: this.form.title,
          dirId: this.form.dirId,
          hasTitle: !!this.form.title,
          hasDirId: !!this.form.dirId,
          htmlContentLength: this.form.htmlContent?.length,
          wordCount: this.wordCount,
          imageCount: this.imageCount,
          workspaceSlug: this.workspaceSlug

        });
        
        // 手动验证，避免表单验证组件的问题
        if (!this.form.title || this.form.title.trim() === '') {
          this.$message.error('请输入文档标题');
          return null;
        }
        
  /*      if (!this.form.dirId) {
          this.$message.error('请选择文档目录');
          return null;
        }*/
   // 调试：检查dirId转换
    console.log('【DEBUG】getFormData - 原始dirId:', this.form.dirId)
    console.log('【DEBUG】dirId类型:', typeof this.form.dirId)
    
    let dirIdValue
    if (typeof this.form.dirId === 'object' && this.form.dirId !== null) {
      dirIdValue = this.form.dirId.id
      console.log('【DEBUG】从对象中提取id:', dirIdValue)
    } else {
      dirIdValue = this.form.dirId
      console.log('【DEBUG】直接使用值:', dirIdValue)
    }  
   
        
        // 确保Markdown内容是最新的
        this.convertToMarkdown();
        
        // 构建提交数据
        const submitData = {
          title: this.form.title.trim(),
          dirId: this.form.dirId,
          description: this.form.description || '',
          docAuthor: this.form.docAuthor || this.userName,
          htmlContent: this.form.htmlContent,
          markdownContent: this.form.markdownContent || '',
          imageReferences: this.form.imageReferences || [],
          imageCount: this.imageCount,
          wordCount: this.wordCount
        };
        
        console.log('【EDITOR】准备提交的数据:', {
          title: submitData.title,
          dirId: submitData.dirId,
          htmlContentLength: submitData.htmlContent?.length
        });
        
        return submitData;
        
      } catch (error) {
        console.error('获取表单数据失败:', error);
        this.$message.error('准备提交数据时出错');
        return null;
      }
    },
    
    // 重置表单
    resetForm() {
      if (this.$refs.editorForm) {
        this.$refs.editorForm.resetFields()
      }
      this.form = {
        title: '',
        dirId: this.defaultDirId || null,
        description: '',
        docAuthor: this.userName,
        htmlContent: '',
        markdownContent: '',
        imageReferences: []
      }
      this.showPreview = false
      this.selectedImage = null
      this.currentEditDoc = null
      this.editorHasContent = false
    },
    // 编辑器内容变化
    onEditorContentChange(formData) {
      console.log('编辑器内容变化:', formData)
    },    
  // 图片大小调整
  handleImageResize() {
    if (!this.quill) {
      this.$message.warning('编辑器未初始化')
      return
    }
      // 检查是否有选中的图片
  const selectedImg = this.$el.querySelector('.ql-editor img.selected')
  if (selectedImg) {
    this.showImageResizeDialog(selectedImg)
    return
  }
    const range = this.quill.getSelection()
    if (!range) {
      this.$message.warning('请先点击选择一张图片')
      return
    }
    
    // 获取选中的内容
    const [leaf] = this.quill.getLeaf(range.index)
    
    // 检查是否是图片
      if (leaf && leaf.domNode && leaf.domNode.tagName === 'IMG') {
        const img = leaf.domNode
        this.selectImage(img) // 选中它
        this.showImageResizeDialog(img)
      } else {
        this.$message.warning('请先点击选择一张图片')
      }
  },
  
    // 显示调整对话框
    showImageResizeDialog(imgElement) {
      const currentWidth = imgElement.width || imgElement.naturalWidth

      
      this.$prompt('设置图片尺寸', '调整图片大小', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: `${currentWidth}`,
        inputPlaceholder: '请输入宽度（像素）',
        inputPattern: /^\d+$/,
        inputErrorMessage: '请输入有效的数字'
      }).then(({ value }) => {
        const newWidth = parseInt(value)
        if (newWidth > 0) {
          this.resizeImage(imgElement, newWidth)
        } else {
          this.$message.error('宽度必须大于0')
        }
      }).catch(() => {
        // 取消操作
      })
    },
    
    // 执行调整
    resizeImage(imgElement, width) {
      // 计算保持宽高比的高度
      const naturalWidth = imgElement.naturalWidth
      const naturalHeight = imgElement.naturalHeight
      const aspectRatio = naturalHeight / naturalWidth
      const height = Math.round(width * aspectRatio)
      
      // 更新图片尺寸
      imgElement.width = width
      imgElement.height = height
      imgElement.style.width = `${width}px`
      imgElement.style.height = `${height}px`
      
      // 添加自定义属性
      imgElement.setAttribute('data-custom-width', width)
      imgElement.setAttribute('data-custom-height', height)
      
      this.$message.success(`图片已调整为 ${width}×${height} 像素`)
      
      // 更新编辑器内容
      this.onContentChange({ html: this.quill.root.innerHTML })
    },

    // 另存为处理
    handleSaveAs() {
      if (!this.form.htmlContent || this.form.htmlContent.trim() === '') {
        this.$message.warning('文档内容为空，无法保存')
        return
      }
      
      // 初始化另存为表单
      this.initSaveAsForm()
      
      // 显示对话框
      this.saveAsDialogVisible = true
    },
    
    // 初始化另存为表单
    initSaveAsForm() {
      const originalTitle = this.currentEditDoc?.title || this.form.title || '未命名文档';
      let newTitle = originalTitle;
      
      // 智能生成副本标题
      if (!originalTitle.includes('副本') && !originalTitle.includes('copy')) {
        newTitle = `${originalTitle} - 副本`;
      } else {
        // 如果已经是副本，尝试递增副本编号
        const copyMatch = originalTitle.match(/(.*?)\s*[-_]?\s*副本\s*(\d*)$/);
        if (copyMatch) {
          const baseName = copyMatch[1];
          const copyNum = copyMatch[2] ? parseInt(copyMatch[2]) + 1 : 2;
          newTitle = `${baseName} - 副本${copyNum}`;
        }
      }
      
      this.saveAsForm = {
        id: this.form.id,
        title: newTitle,
        dirId: this.currentEditDoc?.dirId || this.form.dirId,
        description: this.currentEditDoc?.description || this.form.description,
        docAuthor: this.form.docAuthor || this.userName
      };
    },
    
    // 重置另存为表单
    resetSaveAsForm() {
      this.saveAsForm = {
        title: '',
        dirId: null,
        description: '',
        docAuthor: ''
      }
      this.saveAsSubmitting = false
    },    

    // 提交另存为
    async submitSaveAs() {
      try {
        const valid = await this.$refs.saveAsFormRef.validate();
        if (!valid) return;
        
        this.saveAsSubmitting = true;
        
        // 清理图片引用
        const cleanImageReferences = () => {
          if (!this.form.imageReferences || !Array.isArray(this.form.imageReferences)) {
            return [];
          }
          
          return this.form.imageReferences.map(ref => {
            const cleanRef = {};
            cleanRef.imageId = ref.imageId || 0;
            cleanRef.altText = ref.altText || '图片';
            cleanRef.objectKey = ref.objectKey || '';
            
            if (ref.tempUrl) {
              const urlParts = ref.tempUrl.split('?');
              cleanRef.tempUrl = urlParts[0];
            } else {
              cleanRef.tempUrl = '';
            }
            
            cleanRef.position = ref.position || 0;
            return cleanRef;
          });
        };
        
        const formData = {
          id: 0,
          title: this.saveAsForm.title,
          dirId: this.saveAsForm.dirId,
          description: this.saveAsForm.description,
          docAuthor: this.saveAsForm.docAuthor,
          htmlContent: this.form.htmlContent,
          markdownContent: this.form.markdownContent,
          imageReferences: cleanImageReferences(),
          workspaceSlug: this.workspaceSlug,
          wordCount: this.wordCount,
          imageCount: this.imageCount
        };
        
        console.log('另存为数据:', formData);
        
        const res = await createEditorDoc(formData);
        console.log("createEditorDoc",res);
        if (res) {

          this.saveAsDialogVisible = false;
            // 关键：立即重置表单
            this.resetSaveAsForm();          
          
          const savedDoc = res.data;
          if(savedDoc.code ==200){
              this.$message.success('另存为成功');
              console.log('另存为成功，返回的文档数据:', savedDoc);
              this.saveAsForm.title = savedDoc.data.title;
              this.currentEditDoc.title =  savedDoc.data.title;
              console.log( this.saveAsForm.title )          
            // 关键：更新当前编辑的文档信息
            this.updateCurrentDocAfterSaveAs(savedDoc);
              // 调用刷新方法
              //this.refreshDocumentState(savedDoc);          
            // 触发保存成功事件
            this.$emit('save-as-success', savedDoc);          
          } else if (res.data.code === 500 && res.data.message && 
                    res.data.message.includes('已存在标题为')) {
            this.$message.error(res.data.message);
          } else {
            this.$message.error(res.data.message || '另存为失败');
          }
        }
      } catch (error) {
        console.error('另存为失败:', error);
        this.$message.error('另存为失败: ' + (error.message || '未知错误'));
      } finally {
        this.saveAsSubmitting = false;
      }
    },

// 新增方法：更新当前文档信息
updateCurrentDocAfterSaveAs(savedDoc) {
  console.log('【另存为】更新当前文档信息:', savedDoc);
  
  // 更新当前编辑文档对象
 /* this.currentEditDoc = {
    ...savedDoc,
    // 确保字段名与组件期望的一致
    id: savedDoc.id,
    title: savedDoc.title,
    dirId: savedDoc.dirId,
    description: savedDoc.description,
    docAuthor: savedDoc.docAuthor,
    htmlContent: savedDoc.htmlContent,
    html_content: savedDoc.htmlContent, // 兼容字段
    markdownContent: savedDoc.markdownContent,
    markdown_content: savedDoc.markdownContent, // 兼容字段
    imageReferences: savedDoc.imageReferences,
    image_references: savedDoc.imageReferences // 兼容字段
  };*/
  
  // 更新表单数据
  this.saveAsForm.title = savedDoc.data.title;
  this.saveAsForm.dirId = savedDoc.data.dirId;
//  this.saveAsForm.description = savedDoc.data.description || '';
//  this.saveAsForm.docAuthor = savedDoc.docAuthor || this.userName;
//  this.saveAsForm.htmlContent = savedDoc.htmlContent || '';
 // this.saveAsForm.markdownContent = savedDoc.markdownContent || '';
  
 console.log("xxxx",this.saveAsForm,  savedDoc.data);
  // 如果后端返回了图片引用，也更新
  if (savedDoc.imageReferences) {
    this.form.imageReferences = savedDoc.imageReferences;
  }
  
  // 更新编辑器标题显示
  this.editorHasContent = !!(savedDoc.htmlContent && savedDoc.htmlContent.trim());
  
  console.log('【另存为】更新后的表单数据:', {
    title: this.form.title,
    dirId: this.form.dirId,
    editorHasContent: this.editorHasContent
  });
  
  // 如果编辑器已经初始化，确保内容正确显示
  if (this.quill) {
    this.$nextTick(() => {
      // 重新设置编辑器内容（确保显示最新的）
      this.setEditorContent();
    });
  }
  
  // 通知父组件文档已更新
  this.$emit('document-updated', savedDoc);
},
    
    // 根据目录ID获取目录名称
    getDirName(dirId) {
      if (!dirId || !this.dirs || this.dirs.length === 0) return '未选择'
      
      // 如果dirId是对象
      if (typeof dirId === 'object') {
        return dirId.name || '未知目录'
      }
      
      // 如果dirId是数字
      const dir = this.dirs.find(d => d.id === dirId || (typeof d === 'object' && d.id === dirId))
      return dir ? dir.name : '未知目录'
    },  

    // 设置点击编辑器外部监听
    setupClickOutsideListener() {
      // 延迟绑定，避免立即触发
      setTimeout(() => {
        this.clickOutsideHandler = (e) => {
          // 如果点击的不是图片，也不是调整大小按钮
          if (e.target.tagName !== 'IMG' && !e.target.closest('.highlight-button')) {
            this.clearImageSelection();
          }
        };
        
        document.addEventListener('click', this.clickOutsideHandler);
      }, 100);
    },

    // 移除点击外部监听
    removeClickOutsideListener() {
      if (this.clickOutsideHandler) {
        document.removeEventListener('click', this.clickOutsideHandler);
        this.clickOutsideHandler = null;
      }
    },  

    // 完整的状态更新方法
    refreshDocumentState(newDocData) {
      console.log('刷新文档状态:', newDocData);
      
      // 1. 更新当前编辑文档
      this.currentEditDoc = {
        ...newDocData,
        // 确保兼容性
        html_content: newDocData.htmlContent,
        markdown_content: newDocData.markdownContent,
        image_references: newDocData.imageReferences
      };
      
      // 2. 更新表单数据
      Object.assign(this.form, {
        title: newDocData.title,
        dirId: newDocData.dirId,
        description: newDocData.description || '',
        docAuthor: newDocData.docAuthor || this.userName,
        htmlContent: newDocData.htmlContent || '',
        markdownContent: newDocData.markdownContent || '',
        imageReferences: newDocData.imageReferences || []
      });
      
      // 3. 更新保存状态
      this.editorHasContent = true;
      
      // 4. 如果编辑器存在，确保内容正确显示
      if (this.quill) {
        this.$nextTick(() => {
          // 检查是否需要更新编辑器内容
          const editorContent = this.quill.root.innerHTML;
          if (editorContent !== newDocData.htmlContent) {
            console.log('检测到内容不一致，更新编辑器内容');
            this.setEditorContent();
          }
        });
      }
      
      // 5. 通知父组件
      this.$emit('document-refreshed', newDocData);
      
      console.log('文档状态刷新完成');
    },  
    // 在编辑器中替换图片URL的方法
    replaceImageUrlsInContent() {
      if (!this.form.htmlContent) return;
      
      let updatedHtml = this.form.htmlContent;
      this.form.imageReferences.forEach(ref => {
        if (ref.objectKey && ref.tempUrl) {
          // 替换HTML中的图片src
          const regex = new RegExp(`src="[^"]*${ref.objectKey}[^"]*"`, 'g');
          updatedHtml = updatedHtml.replace(regex, `src="${ref.tempUrl}"`);
          
          // 同时更新Markdown中的图片引用
          if (this.form.markdownContent) {
            const mdRegex = new RegExp(`\\!\\[[^\\]]*\\]\\([^)]*${ref.objectKey}[^)]*\\)`, 'g');
            this.form.markdownContent = this.form.markdownContent.replace(
              mdRegex, 
              `![${ref.altText}](${ref.tempUrl})`
            );
          }
        }
      });
      
      this.form.htmlContent = updatedHtml;
      
      // 如果编辑器已加载，更新内容
      if (this.quill) {
        this.setEditorContent();
      }
    },
    
    async refreshImageUrls() {
      if (!this.form.imageReferences || !this.form.imageReferences.length) {
        return;
      }
      
      console.log('开始刷新图片URL');
      
      try {
        // 收集需要刷新的图片信息
        const imageRequests = this.form.imageReferences.map(ref => ({
          ossObjectKey: ref.objectKey,
          originalFilename: ref.altText ? `${ref.altText}.png` : 'image.png',
          // 需要tenantId，可以从当前用户信息获取
          tenantId: this.tenantId || 0
        }));
        
        // 调用后端批量生成图片URL的接口
        const response = await this.$api.post('/aics/image_library/batch-generate-urls', {
          images: imageRequests
        });
        
        if (response.data.code === 200) {
          const urlMap = {};
          response.data.data.forEach(item => {
            urlMap[item.objectKey] = item.signedUrl;
          });
          
          // 更新图片引用
          this.form.imageReferences = this.form.imageReferences.map(ref => {
            if (ref.objectKey && urlMap[ref.objectKey]) {
              return {
                ...ref,
                tempUrl: urlMap[ref.objectKey]
              };
            }
            return ref;
          });
          
          // 更新内容中的图片URL
          this.replaceImageUrlsInContent();
          
          console.log('图片URL刷新完成');
          this.$message.success('图片已刷新');
        }
      } catch (error) {
        console.error('刷新图片URL失败:', error);
        this.$message.warning('图片刷新失败，部分图片可能无法显示');
      }
    },
    // 设置键盘事件监听
    setupKeyboardListener() {
      if (this.keyboardHandler) {
        this.removeKeyboardListener();
      }
      
      this.keyboardHandler = (e) => {
        if (!this.hasSelectedImage || !this.selectedImageElement) return;
        
        // 处理删除键
        if (e.key === 'Delete' || e.key === 'Backspace') {
          e.preventDefault(); // 阻止默认删除行为
          e.stopPropagation(); // 阻止事件冒泡
          
          // 删除选中的图片
          this.deleteSelectedImage();
        }
        
        // 处理Esc键（取消选择）
        if (e.key === 'Escape') {
          this.clearImageSelection();
        }
      };
      
      // 监听键盘事件
      document.addEventListener('keydown', this.keyboardHandler);
    },

    // 移除键盘事件监听
    removeKeyboardListener() {
      if (this.keyboardHandler) {
        document.removeEventListener('keydown', this.keyboardHandler);
        this.keyboardHandler = null;
      }
    },

    // 删除选中的图片
    deleteSelectedImage() {
      if (!this.selectedImageElement || !this.quill) return;
      
      try {
        // 找到图片在Quill中的索引
        const index = this.getImageIndexInQuill(this.selectedImageElement);
        if (index !== -1) {
          // 从Quill中删除图片
          this.quill.deleteText(index, 1, 'user');
          
          // 从图片引用中删除
          this.removeImageFromReferences(this.selectedImageElement);
          
          // 清除选择状态
          this.clearImageSelection();
          
          // 提示用户
          this.$message.success('图片已删除');
          
          // 更新内容
          this.onContentChange({ htmlContent: this.quill.root.innerHTML });
        }
      } catch (error) {
        console.error('删除图片失败:', error);
        this.$message.error('删除图片失败');
      }
    },

    // 从图片引用中删除
    removeImageFromReferences(imgElement) {
      if (!this.form.imageReferences || !imgElement.src) return;
      
      // 提取图片的objectKey
      const objectKey = this.extractObjectKeyFromUrl(imgElement.src);
      
      // 过滤掉删除的图片引用
      this.form.imageReferences = this.form.imageReferences.filter(ref => {
        return ref.objectKey !== objectKey;
      });
    },    
  }
}
</script>

<style scoped>
/* 最外层容器 - 固定高度 */
.rich-editor-container {
  width: 100%;
  height: 700px; /* 固定高度，可以根据需要调整 */
  display: flex;
  flex-direction: column;
}

/* 编辑器主区域 */
.editor-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  overflow: hidden; /* 重要：防止内容溢出到页面 */
  background: #fff;
}


/* 头部 - 固定高度 */
.editor-header {
    min-height: 40px; /* 减小最小高度 */
  padding: 6px 15px; /* 减小内边距 */
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
  height: 50px; /* 固定头部高度 */
  box-sizing: border-box;
}

.editor-title {
  font-weight: 600;
  color: #303133;
  font-size: 12px;
}
/* 编辑器和预览区域容器 */
.editor-preview-container {
  flex: 1; /* 占据剩余空间 */
  min-height: 0; /* 重要：防止flex项目溢出 */
  position: relative;
  display: flex;
  flex-direction: column;
}

/* 核心：编辑/预览主区域 - 占据剩余空间并内部滚动 */
.editor-main-area {
  flex: 1;
  min-height: 0; /* 关键：允许flex项目缩小 */
  overflow: hidden; /* 隐藏外层滚动，内部组件自己处理 */
  position: relative;
}

.editor-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 编辑器包装器 */
.editor-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Quill 编辑器容器 */
::v-deep .quill-editor {
  height: 100% !important;
  display: flex;
  flex-direction: column;
}



/* 预览包装器 */
.preview-wrapper {
  height: 100%;
  overflow-y: auto; /* 预览内容可以滚动 */
  background: #fafafa;
}

/* 预览内容区域 */
.preview-content {
  padding: 20px;
  min-height: 100%;
  box-sizing: border-box;
}

.preview-content >>> h1,
.preview-content >>> h2,
.preview-content >>> h3 {
  margin: 20px 0 10px 0;
  color: #303133;
}

.preview-content >>> p {
  margin: 10px 0;
}

.preview-content >>> img {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.preview-content >>> ul,
.preview-content >>> ol {
  padding-left: 20px;
  margin: 10px 0;
}

.preview-content >>> li {
  margin: 4px 0;
}

.preview-content >>> a {
  color: #409eff;
  text-decoration: none;
}

.preview-content >>> a:hover {
  text-decoration: underline;
}

/* 空状态预览 */
.preview-empty {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 编辑器页脚 */
.editor-footer {
  flex-shrink: 0;
  padding: 8px 16px;
  background: #f5f7fa;
  border-top: 1px solid #e4e7ed;
  text-align: right;
  height: 40px; /* 固定页脚高度 */
  box-sizing: border-box;
}

.word-count {
  font-size: 12px;
  color: #909399;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.divider {
  color: #dcdfe6;
}

.image-picker-dialog {
  height: 60vh;
  min-height: 400px;
}

/* 编辑器样式调整 */
::v-deep .ql-editor {
  min-height: 400px !important;
  background-color: white !important;
    user-select: text;
}

::v-deep .ql-toolbar {
  border-bottom: 1px solid #e4e7ed;
  background: #fafafa;
  flex-shrink: 0; /* 固定工具栏高度 */
}

/* 调整 Quill 编辑器内部样式 */
::v-deep .ql-container {
  flex: 1 !important;
  overflow: auto !important;
  min-height: 0 !important;
}

::v-deep .ql-toolbar .ql-formats {
  margin-right: 12px;
}

::v-deep .ql-toolbar button {
  margin: 0 2px;
}

::v-deep .ql-toolbar button:hover {
  background: #e4e7ed;
}

::v-deep .ql-toolbar .ql-active {
  background: #409eff;
  color: white;
}

::v-deep .ql-editor img {
  display: block !important;
  max-width: 100% !important;
  height: auto !important;
  user-select: none;
  -webkit-user-select: none;
  vertical-align: baseline;  
}

.tip {
  font-size: 10pt;
  color: #909399;
}

::v-deep .el-dialog__body {
  padding: 20px;
}

/* 带图标的按钮样式 */
.btn-with-icon {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.btn-with-icon .icon {
  vertical-align: middle;
}

::v-deep .ql-editor {
  min-height: 300px !important; /* 最小高度，但可以超过 */
  height: auto !important; /* 自动高度，内容多时会扩展 */
  overflow-y: visible !important; /* 编辑器内部自然流动 */
  padding-bottom: 50px; /* 给内容一些底部空间 */
}
::v-deep .ql-editor img {
  display: block !important;
  max-width: 100% !important;
  height: auto !important;
}

/* 添加一个强制显示内容的样式 */
::v-deep .ql-editor * {
  opacity: 1 !important;
  visibility: visible !important;
}
/* 选中的图片样式 */
::v-deep .ql-editor img.selected {
  outline: 3px solid #FF6B6B !important;
  box-shadow: 0 0 10px rgba(255, 107, 107, 0.7) !important;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  z-index: 10;
}

::v-deep .ql-editor img {
  cursor: pointer;
  transition: outline 0.2s;
}

::v-deep .ql-toolbar + .ql-container {
  border-top: none !important;
}

::v-deep .ql-container.ql-snow {
  border: none !important;
}

/* 统计信息区域 */
.editor-stats {
  display: flex;
  align-items: center;
  gap: 15px;
  font-size: 12px;
  color: #606266;
  background: rgba(255, 255, 255, 0.8);
  padding: 4px 10px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

/* 高度计算辅助类 */
.height-500 { height: 500px; }
.height-600 { height: 600px; }
.height-700 { height: 700px; }
.height-800 { height: 800px; }
.height-900 { height: 900px; }

/* 响应式调整 */
@media (max-height: 800px) {
  .rich-editor-container {
    height: 600px;
  }
}

@media (max-height: 600px) {
  .rich-editor-container {
    height: 450px;
  }
}

/* 确保对话框中的编辑器也有合适高度 */
::v-deep .editor-dialog .rich-editor-container {
  height: 550px;
}

/* 对话框样式调整 */
::v-deep .editor-dialog .el-dialog__body {
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
}

/* 强制固定高度的备用方案 */
.fixed-height-container {
  height: 600px; /* 固定高度 */
}
.fixed-height-container .editor-preview-container {
  height: 500px; /* 计算高度：总高 - 头部 - 页脚 */
}

/* 添加一个类用于控制父容器高度 */
.parent-height-control {
  height: 100%;
  min-height: 500px; /* 最小高度 */
  max-height: 800px; /* 最大高度，可根据需要调整 */
}

/* 高亮按钮样式 */
.highlight-button {
  background-color: rgba(255, 107, 107, 0.1) !important;
  border-color: #FF6B6B !important;
  animation: button-pulse 1.5s infinite;
  position: relative;
}

.highlight-button::after {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border: 1px solid #FF6B6B;
  border-radius: 50%;
  animation: button-glow 2s infinite;
}

/* 脉冲动画 */
@keyframes button-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 107, 107, 0.4);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(255, 107, 107, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 107, 107, 0);
  }
}

/* 发光动画 */
@keyframes button-glow {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.05);
  }
}

/* 选中的图片样式 */
::v-deep .ql-editor img.selected {
  outline: 3px solid #FF6B6B !important;
  box-shadow: 0 0 10px rgba(255, 107, 107, 0.7) !important;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

::v-deep .ql-editor img.selected::after {
  content: '✓ 已选中';
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
  background: #FF6B6B;
  color: white;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

::v-deep .ql-editor img.selected::before {
  content: '';
  position: absolute;
  top: -5px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 0 5px 5px 5px;
  border-style: solid;
  border-color: transparent transparent #FF6B6B transparent;
}

/* 工具提示优化 */
.el-tooltip.highlight-tooltip .el-tooltip__popper {
  background-color: #FF6B6B !important;
  color: white !important;
  border-color: #FF6B6B !important;
}

.el-tooltip.highlight-tooltip .popper__arrow::after {
  border-top-color: #FF6B6B !important;
}

/* 按钮容器，用于更好的交互 */
.button-container {
  position: relative;
  display: inline-block;
}

/* 选中状态指示器 */
.selected-indicator {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 8px;
  height: 8px;
  background-color: #FF6B6B;
  border-radius: 50%;
  animation: indicator-blink 1s infinite;
}

@keyframes indicator-blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}
.document-title{
  font-weight: 500;
  font-family: 微软雅黑;
  color: #409EFF;
}

::v-deep .save-as-dialog .el-dialog__header {
  padding: 5px 10px;
  border-bottom: 1px solid #e4e7ed;
}

::v-deep .save-as-dialog .el-dialog__title {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
}

::v-deep .save-as-dialog .el-dialog__headerbtn {
  top: 5px;
  right: 5px;
  font-size: 10px;
}

/* 另存为表单样式 */
.save-as-form {
  max-height: 70vh;
  overflow-y: auto;
  padding-right: 10px;
}
.form-content {
  padding: 0 10px;
}
.form-section {
  margin-bottom: 24px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e8eaed;
}
.form-section:last-child {
  margin-bottom: 0;
}
.section-title {
  margin: 0 0 16px 0;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  padding-bottom: 8px;
  border-bottom: 1px solid #e4e7ed;
}
/* 目录选择器包装 */
.dir-select-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.field-tip {
  color: #909399;
  cursor: help;
  flex-shrink: 0;
}

/* 源文档信息区域 */
.source-doc-section {
  background: #f0f9ff;
  border-color: #d1e9ff;
}

.source-doc-info {
  padding: 8px 0;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px 16px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  min-height: 24px;
}

.info-item.full-width {
  grid-column: 1 / -1;
}

.info-label {
  flex-shrink: 0;
  color: #606266;
  font-size: 13px;
  font-weight: 500;
  margin-right: 8px;
  line-height: 24px;
}

.info-value {
  flex: 1;
  color: #303133;
  font-size: 13px;
  line-height: 24px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.info-value.desc-text {
  color: #666;
  font-style: italic;
}

/* 预览按钮 */
.preview-action {
  margin-top: 16px;
  text-align: center;
  padding-top: 12px;
  border-top: 1px dashed #d1e9ff;
}

.preview-action .el-button {
  color: #409EFF;
}

.preview-action .el-button:hover {
  color: #66b1ff;
}

/* 对话框页脚 */
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #e4e7ed;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .info-grid {
    grid-template-columns: 1fr;
  }
  
  .save-as-form {
    padding-right: 0;
  }
}
</style>

<style>
/* 预览对话框全局样式 */
.source-preview-dialog .el-message-box {
  max-width: 90%;
}

.source-preview-dialog .el-message-box__content {
  max-height: 70vh;
  overflow-y: auto;
}

.source-preview {
  padding: 16px;
  background: #fff;
  border-radius: 4px;
}

.source-preview h1,
.source-preview h2,
.source-preview h3 {
  margin: 16px 0 8px 0;
  color: #303133;
}

.source-preview p {
  margin: 8px 0;
  line-height: 1.6;
}

.source-preview img {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
  margin: 8px 0;
}

/* 另存为对话框头部优化 */
.save-as-dialog .el-dialog__header {
  padding: 16px 20px 12px;
  border-bottom: 1px solid #e4e7ed;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.save-as-dialog .el-dialog__title {
  color: white;
  font-size: 16px;
  font-weight: 600;
}

.save-as-dialog .el-dialog__headerbtn {
  top: 16px;
}

.save-as-dialog .el-dialog__headerbtn .el-dialog__close {
  color: white;
}

.save-as-dialog .el-dialog__headerbtn:hover .el-dialog__close {
  color: #f2f6fc;
}
:deep(.el-select .el-input .el-select__caret) {
  font-family: element-icons !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: baseline;
  display: inline-block;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 修复下拉框整体样式 */
:deep(.el-select-dropdown) {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

:deep(.el-select) {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

/* 如果使用的是SVG图标版本 */
:deep(.el-select .el-input .el-select__caret.is-reverse) {
  transform: rotateZ(180deg);
}

/* 确保选择框有正确的宽度 */
:deep(.el-select .el-input) {
  width: 100%;
}

/* 删除提示样式 */
.delete-hint {
  position: absolute;
  bottom: -25px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(255, 107, 107, 0.9);
  color: white;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 11px;
  white-space: nowrap;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  pointer-events: none;
  animation: hint-fade-in 0.3s ease;
}

@keyframes hint-fade-in {
  from { opacity: 0; transform: translateX(-50%) translateY(5px); }
  to { opacity: 1; transform: translateX(-50%) translateY(0); }
}

/* 强制显示列表标记 */
::v-deep .ql-editor ol {
  list-style-type: decimal !important;
  padding-left: 2em !important;
}

::v-deep .ql-editor ul {
  list-style-type: disc !important;
  padding-left: 2em !important;
}

::v-deep .ql-editor li {
  display: list-item !important;
  list-style-position: outside !important;
}

/* 确保列表标记可见 */
::v-deep .ql-editor ol li::before {
  content: counter(list-item) ". " !important;
  color: inherit !important;
  font-weight: normal !important;
}

::v-deep .ql-editor ul li::before {
  content: "•" !important;
  color: inherit !important;
  font-weight: bold !important;
}
</style>